#import "../fragments/nutshell-marketing-banner-info.graphql"

query GetNutshellMarketingBannerInfo {
    nutshellMarketingStats {
        ...NutshellMarketingBannerInfo
    }
}
